define ['./complete.scss'], () ->
  ($scope, $state, $stateParams, RentappService) ->



// WEBPACK FOOTER //
// ./components/payment/complete/complete.coffee